import { useCallback, useEffect, useState } from "react"
import {
  buildMockHomeMotivation,
  getHomeMotivation,
} from "@/api/homeMotivationApi"
import { getGameApiErrorMessage } from "@/api/gameApiErrors"
import { USE_MOCK_BATTLE } from "@/constants/guardians"
import { HomeMotivationStatus } from "@/types/homeMotivation"
import { useGuardiansPassport } from "@/features/passport/GuardiansPassportContext"

export function useHomeMotivation(refreshKey = 0) {
  const { passport } = useGuardiansPassport()
  const [status, setStatus] = useState<HomeMotivationStatus | null>(null)
  const [loading, setLoading] = useState(true)

  const load = useCallback(async () => {
    if (!passport) {
      setStatus(null)
      setLoading(false)
      return
    }
    try {
      if (USE_MOCK_BATTLE) {
        setStatus(buildMockHomeMotivation())
        return
      }
      setStatus(await getHomeMotivation())
    } catch (e) {
      if (import.meta.env.DEV) {
        console.warn("[home-motivation]", getGameApiErrorMessage(e))
      }
      setStatus(null)
    } finally {
      setLoading(false)
    }
  }, [passport])

  useEffect(() => {
    void load()
  }, [load])

  useEffect(() => {
    if (refreshKey > 0) void load()
  }, [refreshKey, load])

  return { status, loading, setStatus }
}
